import * as React from 'react';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { UitkFigure } from 'uitk-react-images';

export interface UrgencyMessagingCardProps {
  className?: string;
  icon?: string;
  urgencyText?: string;
}

export const UrgencyMessagingCard = ({ className, icon, urgencyText }: UrgencyMessagingCardProps) => {
  if (!urgencyText) {
    return null;
  }

  return (
    <UitkMessagingCard className={className} imageLayout={UitkMessagingCardImageLayout.LEFT}>
      {icon && (
        <UitkMessagingCardMedia>
          <UitkFigure ratio={UitkFigure.AspectRatio.R1_1} src={icon} />
        </UitkMessagingCardMedia>
      )}
      <UitkMessagingCardSection>
        <p className="uitk-type-300">{urgencyText}</p>
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};
